import React from 'react';
import './linked-entity-card.css';

export default function EntityLinkButton({ className = '', children, onClick, ...props }) {
  return <button type="button" {...props} className={`entity-link-button ${className}`.trim()}
    onClick={(event) => { event.stopPropagation(); onClick?.(event); }}>{children}</button>;
}
